import { topListCriteriaToString } from "./toplist_criteria";
export function urlToString(params) {
    switch (params.type) {
        case "toplist":
            if (params.location == null && params.resort !== null)
                params.location = "sverige";
            if (params.location == null)
                return `/topplistor/${topListCriteriaToString(params.property)}`;
            if (params.resort == null)
                return `/topplistor/${topListCriteriaToString(params.property)}/${params.location}`;
            return `/topplistor/${topListCriteriaToString(params.property)}/${params.location}/${params.resort}`;
        case "resort":
            return `/skidort/${params.resort}`;
        case "search":
            return `/sök`;
        case "settings":
            return urlToString(params.parent) + "/inställningar";
    }
}
;
export function URLComponents(url) {
    let components = decodeURIComponent(url).split("/");
    // URL will always start with a /
    if (components[0] == "")
        components.shift();
    // Allow trailing slashes
    if (components[components.length - 1] == "")
        components.pop();
    return components;
}
